<!-- 
    name: 覃刚
    function: nhf管理-新增
    date: 2021-03-09
 -->
<template>
  <div class="containerPaddingBlock">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="配方原料">
        <blend-material-box :rowId="rowId" :factoryId="factoryId" :details="details"/>
      </a-tab-pane>
      <a-tab-pane key="2" tab="配方营养需要量">
        <blend-analysis-box :rowId="rowId" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import BlendMaterialBox from "./BlendMaterialBox";
import BlendAnalysisBox from "./BlendAnalysisBox";
export default {
  props: ['factoryId','rowId','details'],
  components:{
    BlendMaterialBox,
    BlendAnalysisBox
  },
}
</script>